/**
 * Бренд инстанса: логотип из настроек или название с монограммой — единственное место
 * цвета brand. Логотип — словесный знак, поэтому название рядом с ним не повторяется.
 */
export function Brand({ name, logoUrl }: { name: string; logoUrl?: string | null | undefined }) {
  if (logoUrl) {
    return (
      <span className="flex items-center px-2 py-1">
        <img
          src={logoUrl}
          alt={name}
          className="h-7 w-auto max-w-[200px] object-contain object-left"
        />
      </span>
    );
  }
  return (
    <span className="flex items-center gap-2 px-2 py-1 text-base font-semibold text-ink">
      <span
        aria-hidden="true"
        className="grid size-7 shrink-0 place-items-center rounded-sm bg-brand text-sm text-on-brand"
      >
        {name.slice(0, 1).toUpperCase()}
      </span>
      {name}
    </span>
  );
}
